module.exports = __webpack_public_path__ + "img/cash.761ac1c6.png";